import { Component } from '@angular/core';

/**
 * Generated class for the Spinner_2Component component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'spinner-2',
  templateUrl: 'spinner-2.html'
})
export class Spinner_2Component {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/spinner-2/spinner-2.ts